import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { setApiClient } from "./lib/apiClient";
import { createLocalStorageClient } from "./lib/localStorageClient";
import { createHttpClient } from "./lib/httpClient";
import { runMigrations } from "./lib/storage-migrations";
import "./index.css";

// Mode selection (CLAUDE.md § Studio mode vs Connected mode):
//   - Studio mode (default): localStorage-only; no network calls, no
//     real payments, no real merchant. Leave VITE_COSTPLUS_MODE unset.
//   - Connected mode: talks to the Go orchestrator via cookies+CSRF.
//     Set VITE_COSTPLUS_MODE=connected and VITE_API_BASE_URL to the
//     orchestrator origin (empty string = same-origin via reverse proxy).
const mode = (import.meta.env.VITE_COSTPLUS_MODE ?? "studio") as
  | "studio"
  | "connected";

if (mode === "connected") {
  const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";
  setApiClient(createHttpClient({ baseUrl }));
} else {
  // Run any pending localStorage schema migrations on boot (Phase -1
  // invariant: persistence is versioned from day one).
  const migrationResult = runMigrations();
  if (migrationResult.migrated > 0 || migrationResult.errors > 0) {
    console.info("[studio] storage migrations:", migrationResult);
  }
  setApiClient(createLocalStorageClient());
}

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
